module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "aint",
      "title": "Introduction"
    }
  }, [_c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#int"
    }
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("“W")]), _c('span', {
    staticClass: "bro"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HAT IS")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILIPINO FOOD")]), _vm._v("?”")]), _vm._v(" asked my Italian mother-in-law, whose culinary repertoire doesn’t stray out of the bounds of traditional Italian cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I cleared my throat. I needed to buy some time to collect my thoughts before I answered. How do you define a cuisine that’s a hodgepodge of numerous foreign influences and is almost as varied as the 7,000-plus islands that make up the nation?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Umm,” I said, pulling my earlobe with my thumb and forefinger, trying to silence the mocking voice in my head. “It’s a mix of different kinds of cuisines.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Struggling to find the words to accurately express the complexity of my homeland’s culinary traditions, I started to babble about the history of the Philippines and the many influences that molded the food, from the Malay settlers and the Chinese migrants and traders, to the Spanish and American colonizers and so on. ("), _c('i', [_vm._v("Yeah, she’s dying to get a Philippine history lecture.")]), _vm._v(") And about how, in general, it’s not as spicy-hot as the food of nearby countries such as Thailand and Malaysia ("), _c('i', [_vm._v("Right, as if she’s tried Thai and Malaysian food")]), _vm._v("), though some regions in the Philippines like their dishes hot. ("), _c('i', [_vm._v("Huh? Is it or is it not hot?")]), _vm._v(") And how it’s heavily rice based ("), _c('i', [_vm._v("Oh, she’ll think risotto!")]), _vm._v(")—not like risotto, but rice cooked separately and then eaten together with another dish. ("), _c('i', [_vm._v("Another dish? A Filipino dish? So back to the question “What is Filipino food?” Brava, Jacqueline! You’ve further alienated your mother-in-law from Filipino food!")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother-in-law nodded her head, as though she understood, but I knew my explanation was anything but clear to her. She was as clueless about Filipino food as she was before she posed the question. Her nod was out of sympathy, to relieve me from my agony. She never asked me about Filipino food again.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Trying to define Filipino cuisine in a few sentences will always fall short in capturing its essence.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Complex and diverse, Filipino cuisine is ineffable. Trying to define it in a few sentences will always fall short in capturing its essence. To make "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("sense of Filipino food, it has to be experienced, with all the emotions and sensations that are associated with it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If only I had thought to tell my mother-in-law my story about torta, or omelet, a favorite childhood dish. If only I told her about my lola (grandma) pounding the heads she severed from fresh shrimp in the kitchen while her transistor radio blared melodrama. How the rich, tomalley-like flavor she extracted from the shrimp heads perked up the dish’s flavor. How she cleverly packed the stovetop frittata with as much substance as flavor to balance our diet and feed three families on a shoestring budget. The way she relentlessly beat egg whites with a fork from goo to stiff foam with the same hand she used to beat us, her grandchildren, to form us into better shapes of ourselves. The way she made an insignificant, unremarkable egg strong enough to hold a cornucopia of ingredients together. And why—after many years have passed, and mindsets on child-rearing and good eating have changed—my memories of torta embody love without fear, flavor without bitterness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A story, in addition to preparing the dish for my mother-in-law to see, smell, taste, and feel, would have given her a far better understanding of and connection to Filipino food than any definition I could have strung together. I missed out on what could have been a great opportunity to break the cultural barrier that stood between me and the other woman in my husband’s life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An understanding, a connection, and—most of all—an experience. These are what the stories and recipes in this book will put on the table. As food is inevitably entwined with life, this book is as much about people as it is about food.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("As food is inevitably entwined with life, this book is as much about people as it is about food.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Certain dishes evoke memories that, when explored, lead to heartwarming revelations. For me, the sound of a stone pestle crashing into a mortar; the smell of garlic, onions, and fresh shrimp extract simmering in a wok; the golden color and halo shape of a torta; the springy texture of the cooked beaten egg; the steam, caramelized minced meat, and brightly colored bits of vegetables that escape when the torta is sliced; and the savory yet subtly sweet first bite steer me back to the pains and joys of my childhood. When I examine different parts of my life through the lens of torta, I discover empathy and reconciliation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I asked the book’s contributors to share memories and epiphanies accessed through Filipino food. To take their reflections further, each of them developed a recipe inspired by a Filipino dish that means a lot to them. Even though the dishes are common in the Philippines, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("every contributor put his or her own stamp on it. While most may have evolved in varying degrees from the traditional Filipino versions to suit the author’s new way of life, all are, nevertheless, anchored to an authentic Filipino experience.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am awed by the contributions of these men and women. They spoke from the heart and cooked from the soul. As I read and edited their stories, I felt their emotions, saw their worlds through their eyes, and walked in their shoes. As I tested and tasted the recipes, I was drawn to a deeper appreciation of the cuisine’s versatility and the people’s resilience. Our food has been shaped by indigenous hands that, when exposed to hundreds of years of foreign influences, adopted and adapted what they could to their means and liking. The result was a cuisine—morphed in the homeland, distinct from its origins. As millions of Filipinos have traveled abroad and set down roots beyond the archipelago of 7,641 islands, our food, as exemplified by the recipes in this book, persists—and, in fact, is gaining the recognition it deserves in the mainstream. I don’t think it’s because the dishes resist change. It’s because they and the people who create them are able to adapt to new environments and new times, while staying true to themselves. Borrowing the words of Franklin D. Roosevelt: “There are many ways of going forward, but only one way of standing still.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This collection is a buffet. Emotions and flavors from bold to subtle, rustic to refined, and everything in between blaze, just like the cuisine. But though each piece recounts a unique, deeply personal experience, all speak of truths that are universal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hope that this book will help you understand what Filipino food is about in a more profound way—the way you would experience it if a Filipino family member or friend told you about it. If you, like my mother-in-law, are not familiar with the cuisine, this book will shed light; if you are familiar with the food, you will see dishes in a light you’ve never seen them in before. But, most of all, I hope that through this book, you will join us in embracing our differences and celebrating our commonalities—regardless of your food beginnings.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("ABOUT THE RECIPES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The recipes in this book are developed with you in mind—an open-minded person who, every now and then, is in search of heightened food experiences. They are for those who’d like to have a taste of Filipino food at home—wherever that may be—without having to travel far "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("to shop for ingredients, without having to cook for hours on end in the kitchen, and without having to possess special culinary expertise.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most of the ingredients in this book are available in grocery stores or in the Asian food aisle of major supermarkets. A few of the ingredients in some of the recipes, however, may be found only in Asian grocery shops. Though Asian shops dot every part of the world, we give you an option to use easier-to-find alternatives for these ingredients, in case a trip to one might not be convenient.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even if they’re available in shops, it’s difficult to find ingredients if you don’t know what you’re looking for. In the box below, you’ll find an introduction to some of the less-familiar items used in the recipes in this book, all of which are available only in Asian grocers unless specified otherwise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remember, pleasure can be derived not only in eating, but in preparing food as well. I suggest you read the personal narrative before following each recipe. This way you can relive the contributor’s story as you recreate the dish, which will enhance your Filipino food experience. Who knows where this exploration of the senses may lead? Perhaps to a whole new memorable story and recipe of your own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mabuhay!")]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("ANNATTO SEEDS (ATSUETE OR ACHUETE):")])]), _vm._v(" rust-red seeds of the annatto used as natural food coloring; smaller than unpopped popcorn kernels. Also available in Latin markets and in the international aisle of some supermarkets.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("BAGOONG ALAMANG:")])]), _vm._v(" fermented shrimp paste, sold in jars. Bagoong, in general, is fermented seafood paste. There are different varieties depending on the kind of seafood used, but bagoong alamang is the most common.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("BAGOONG MONAMON:")])]), _vm._v(" fermented salted anchovy sauce, sold in jars.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("BANANA BLOSSOM:")])]), _vm._v(" purplish tear-shaped banana heart, about the size of a football.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("BANANA KETCHUP:")])]), _vm._v(" made from mashed bananas but looks like tomato ketchup because of the food coloring used; sold in bottles like ketchup.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("BANANA LEAVES:")])]), _vm._v(" sold folded in bags in the refrigerated or frozen section of Asian grocers; enhance the flavor of food wrapped and cooked in them and serve as natural foil or parchment paper.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("BIHON (BIJON) NOODLES:")])]), _vm._v(" thin, dry rice noodles also known as rice vermicelli; in general, they do not need to be soaked; cook according to package directions.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("BITTER MELON (AMPALAYA):")])]), _vm._v(" rough, greenish-skinned, elongated gourd.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("CALAMANSI:")])]), _vm._v(" Philippine lime, similar in color but smaller than a regular lime. Turns yellow-orange as it matures.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("CHAYOTE:")])]), _vm._v(" greenish-yellow, pear-shaped squash.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("CHICHARRON:")])]), _vm._v(" pork rind or crackling. Also available in supermarkets.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("CHORIZO DE BILBAO:")])]), _vm._v(" a dense, semi-dry, spicy sausage.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("FISH SAUCE (PATIS):")])]), _vm._v(" amber-colored liquid sold in bottles; a few drops lift a dish’s umami flavor. Also available in supermarkets.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    staticClass: "bro"
  }, [_vm._v("GLUTINOUS RICE FLOUR:")])]), _vm._v(" also called sweet or sticky rice flour; has a higher starch content than regular rice flour, which makes it better for thickening sauces.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("GRATED CASSAVA (KAMOTENG KAHOY):")])]), _vm._v(" also called yuca; sold in frozen packs.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("GREEN MANGO:")])]), _vm._v(" unripe mango.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("GREEN PAPAYA:")])]), _vm._v(" unripe papaya.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("JACKFRUIT (LANGKA):")])]), _vm._v(" ripe, sweet, bright yellow fruit sold in cans in syrup; not to be confused with the canned green, young jackfruit packed in brine or water.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("LONG BEANS (SITAW):")])]), _vm._v(" yard-long beans.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("LONG (ASIAN) EGGPLANT:")])]), _vm._v(" long and slim, in contrast to the round, voluptuous Italian eggplant.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("MORINGA (MALUNGGAY):")])]), _vm._v(" leaves of the horseradish tree.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("OKRA:")])]), _vm._v(" also called lady’s finger, a long, five-sided green pod with a pointed end. Also available in the fresh produce section of some supermarkets.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("PIGEON PEAS (KADYOS OR KADIOS):")])]), _vm._v(" tropical peas; sold frozen in bags. Also available in Indian food shops as toovar lilva.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("SPLIT MUNG BEANS (SPLIT BALATONG OR MONGGO):")])]), _vm._v(" small, yellow legumes (whole, unsplit monggo beans are dark green); sold dry.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("SWEET RICE:")])]), _vm._v(" also called glutinous or sticky rice. It is gluten-free, despite the name. Its starchiness gives it a more opaque white color than regular rice and makes it suitable for preparing Filipino sweets and rice cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("SWEET RICE POWDER:")])]), _vm._v(" coarser than glutinous rice flour; can be made by grinding uncooked sweet rice in a blender or coffee grinder.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("UBE HALAYA:")])]), _vm._v(" jam made from boiled, mashed purple yams; sold in jars.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("WATER SPINACH (KANGKONG):")])]), _vm._v(" also called swamp cabbage or, in some Asian shops, morning glory or ong choy; the green stems and either narrow elongated or arrow-shaped leaves of a semi-aquatic plant.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "bro"
  }, [_c('b', [_vm._v("WINGED BEAN (SIGARILYAS):")])]), _vm._v(" four-cornered bean sold fresh; has a milder flavor than a snow pea or green bean.")])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "long beans (sitaw)",
      "height": "389",
      "src": "images/f0005-01.jpg",
      "width": "283"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption0"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_c('i', [_vm._v("long beans (sitaw)")])])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "okra",
      "height": "389",
      "src": "images/f0005-02.jpg",
      "width": "283"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption0"
  }, [_c('i', [_vm._v("okra")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "banana blossom...",
      "src": "images/f0006-01.jpg",
      "width": "440"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption0"
  }, [_c('i', [_vm._v("banana blossom")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "bitter melon...",
      "src": "images/f0007-01.jpg",
      "width": "397"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption0"
  }, [_c('i', [_vm._v("bitter melon (ampalaya)")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "chayote",
      "src": "images/f0008-01.jpg",
      "width": "387"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption0"
  }, [_c('i', [_vm._v("chayote")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "winged bean...",
      "src": "images/f0008-02.jpg",
      "width": "385"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption0"
  }, [_c('i', [_vm._v("winged bean (sigarilyas)")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_c('img', {
    attrs: {
      "alt": "split mung...",
      "src": "images/f0009-01.jpg",
      "width": "387"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption0"
  }, [_c('i', [_vm._v("split mung beans (split balatong or monggo)")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/f0010-01.jpg",
      "width": "397"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption0"
  }, [_c('i', [_vm._v("annatto seeds (also atsuete or achuete)")])])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "calamansi",
      "src": "images/f0011-01.jpg",
      "width": "550"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption0"
  }, [_c('i', [_vm._v("calamansi")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "moringa (malunggay)",
      "src": "images/f0012-01.jpg",
      "width": "433"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption0"
  }, [_c('i', [_vm._v("moringa (malunggay)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-350ae8f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Introduction.vue
// module id = 78
// module chunks = 0